export const rubIcon = () => {
    return ( 
        <svg  xmlns="http://www.w3.org/2000/svg"  
        width="24"  
        height="24"  
        viewBox="0 0 24 24"  
        fill="none"  
        stroke="var(--dark)"  
        strokeWidth="1"  
        strokeLinecap="round"  
        strokeLinejoin="round"  
        className="icon icon-tabler icons-tabler-outline icon-tabler-currency-rubel">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M8 19v-14h6a3 3 0 0 1 0 6h-8" /><path d="M14 15h-8" />
            </svg>
    );
}

